var markers = {
  "heart": "//rachelrothjewelry.com/cdn/shop/t/15/assets/heartformaps.png?v=23739359919060616191790550100",
  "circle": "//rachelrothjewelry.com/cdn/shop/t/15/assets/circleformaps.png?v=124427706924912367351790550100",
  "square": "//rachelrothjewelry.com/cdn/shop/t/15/assets/squareformaps.png?v=3803",
  "house": "//rachelrothjewelry.com/cdn/shop/t/15/assets/houseformaps.png?v=168950170954749380511790550100",
  "star": "//rachelrothjewelry.com/cdn/shop/t/15/assets/starformaps.png?v=12371575111258749771790550100",
}

var isMarkerLoaded = false;
var selectedMarker = 'heart';

mapboxgl.accessToken = 'pk.eyJ1IjoiYW9ibG91ayIsImEiOiJjamVhbzVnajIxMXkwMzNsZTFqeTFldnUxIn0.bAGA6PRx08Gp82ed5ON9cA';

var map = new mapboxgl.Map({
    container: 'map', //https://www.mapbox.com/studio/styles/aoblouk/
    style: 'mapbox://styles/aoblouk/cjfki5f9h0cm82rqgftx3l9fb',
    zoom: 3,
	preserveDrawingBuffer: true,
    center: [-98.46, 38.77]
});
map.addControl(new mapboxgl.NavigationControl(), 'top-right');
var geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken
});
map.addControl(geocoder, 'top-left');

map.addControl(new mapboxgl.GeolocateControl({
    positionOptions: {
        enableHighAccuracy: true
    },
    trackUserLocation: true
}), 'top-right');

map.dragRotate.disable();
map.touchZoomRotate.disableRotation();

var coordinates = document.getElementById('coordinates');
var canvas = map.getCanvasContainer();

var geojson = {
    "type": "FeatureCollection",
    "features": [{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [-98.46, 38.77]
        }
    }]
};

function onMove(e) {
	var coords = e.lngLat;

    // Set a UI indicator for dragging.
    canvas.style.cursor = 'grabbing';

    // Update the Point feature in `geojson` coordinates
    // and call setData to the source layer `point` on it.
    geojson.features[0].geometry.coordinates = [coords.lng, coords.lat];
    map.getSource('points').setData(geojson);
	
	e.originalEvent.stopPropagation();
  	resetEtsyCode();
}

function onUp(e) {
    var coords = e.lngLat;
    canvas.style.cursor = '';

    // Unbind mouse/touch events
    map.off('mousemove', onMove);
    map.off('touchmove', onMove);
  	resetEtsyCode();
}

map.on('load', function() {

    // Add a single point to the map
    loadMarker('heart');
  /*
    map.loadImage(selectedMarker, function(error, image) {
        if (error) throw error;
        map.addImage('heart', image);
        map.addLayer({
            "id": "points",
            "type": "symbol",
            "source": {
                "type": "geojson",
                "data": {
                    "type": "FeatureCollection",
                    "features": [{
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates": [-98.46, 38.77]
                        }
                    }]
                }
            },
            "layout": {
                "icon-image": "heart",
                "icon-size": .3
            }
        });
        onLoad();
    });
   */

    // When the cursor enters a feature in the point layer, prepare for dragging.
    map.on('mouseenter', 'points', function(e) {
        //map.setPaintProperty('point', 'circle-color', '#555555');
        canvas.style.cursor = 'move';
      e.originalEvent.stopPropagation();
    });

    map.on('mouseleave', 'points', function(e) {
        //map.setPaintProperty('point', 'circle-color', '#000000');
        canvas.style.cursor = '';
      e.originalEvent.stopPropagation();
    });

    map.on('mousedown', 'points', function(e) {
        e.preventDefault();
      
        // Prevent the default map drag behavior.
        canvas.style.cursor = 'grab';

        map.on('mousemove', onMove);
        map.once('mouseup', onUp);
      	resetEtsyCode();
    });

    map.on('touchstart', 'points', function(e) {
        if (e.points.length !== 1) return;
		e.preventDefault();
      
        // Prevent the default map drag behavior.
        map.on('touchmove', onMove);
        map.once('touchend', onUp);
      	resetEtsyCode();
    });
});

function loadMarker(markerName)
{
    var markerUrl = markers[markerName];
    selectedMarker = markerName;
    map.loadImage(markerUrl, function(error, image) {
        if (error) throw error;
        if(isMarkerLoaded)
        {
          map.updateImage('marker', image);
          var center = map.getCenter();
          map.setCenter({lng: center.lng, lat: center.lat});
        }
      	else
        {
          map.addImage('marker', image);
          map.addLayer({
            "id": "points",
            "type": "symbol",
            "source": {
                "type": "geojson",
                "data": {
                    "type": "FeatureCollection",
                    "features": [{
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates": [-98.46, 38.77]
                        }
                    }]
                }
            },
            "layout": {
                "icon-image": "marker",
                "icon-size": .3
            }
          });
          isMarkerLoaded = true;
        	onLoad();
        }
    });
}

function updateSelectedIcon(dropdownItem, iconName)
{
    document.getElementById('selected-icon').innerHTML = dropdownItem.innerHTML;
    loadMarker(iconName);
    var itemPropertyInput = document.getElementById('selected-map-marker');
    if(itemPropertyInput)
    {
        itemPropertyInput.value = iconName[0].toUpperCase() + iconName.substr(1);
    }
}

function getOrientation()
{
	var lat = map.getCenter().lat;
	var lng = map.getCenter().lng;
	var zoom = map.getZoom();
    var orientation = map.getBearing();
    var pitch = map.getPitch();
	var text = "";
    var fontSize = "";
	var font = "";
  	if(document.getElementById('backText'))
    {
    	text = document.getElementById('backText').value;
    	fontSize = document.getElementById('fontSize').value;
    	font = document.getElementById('backTextFont').value;
    }
    return {"lat": lat, "lng": lng, "zoom": zoom, "orientation": orientation, "pitch": pitch, "featureLat": geojson.features[0].geometry.coordinates[1], "featureLng": geojson.features[0].geometry.coordinates[0], "text": text, "fontSize": fontSize, "font": font};
}
//map.setBearing allows for rotation

function setOrientation(lat, lng, zoom, orientation, pitch, featureLat, featureLng, text, fontSize, font)
{
	map.setCenter({"lng": lng, "lat": lat});
	map.setZoom(zoom);
    map.rotateTo(orientation);
    map.setPitch(pitch);
    geojson.features[0].geometry.coordinates = [featureLng, featureLat];
        try
        {
			map.getSource('points').setData(geojson);
        }
        catch (error)
        {
            // Points may not be set, so just ignore it
        }
  
  	if(document.getElementById('backText'))
    {
        var fonts = document.getElementById('backTextFont').getElementsByTagName('option');
        for(var i = 0; i < fonts.length; ++i) 
        {
            if(fonts[i].innerHTML == font)
            {
    	        document.getElementById('backTextFont').value = fonts[i].value;
                break;
            }
        }
    	//document.getElementById('backTextFont').value = font;
    	document.getElementById('fontSize').value = fontSize;
    	document.getElementById('backText').value = text;
    }
}

function saveOrientation()
{
    var orientationArray = getOrientation();
    orientationArray['marker'] = selectedMarker;
	setCookie("orientation", JSON.stringify(orientationArray));
	//call this using event listeners
	//save to local storage (set a cookie for shopify to extract text info)
}

function loadOrientation()
{
	var data = JSON.parse(getCookie("orientation"));
	setOrientation(data.lat, data.lng, data.zoom);
    if('marker' in data)
    {
      loadMarker(data['marker']);
    }
    else
    {
      loadMarker('heart');
    }
}

function setCookie(cname, cvalue) {
    var d = new Date();
    d.setTime(d.getTime() + (180 * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

jQuery(function () {
	jQuery('.zoomin').click(function (event) {
		event.preventDefault();
		map.zoomIn();
      	resetEtsyCode();
	});
	jQuery('.zoomout').click(function (event) {
		event.preventDefault();
		map.zoomOut();
      	resetEtsyCode();
	});
	jQuery(window).resize(onResize).resize();
});

function onResize()
{
  		if(jewelryMap)
        {
          var currentMapWidth = jQuery('#jewelry-map').width();
		jQuery('#overlay1, #overlay2, #cutout_overlayimage, #main_overlayimage').width(currentMapWidth);
		jQuery('#cutout_overlayimage, #main_overlayimage').height(jQuery('#jewelry-map').height());
        }
  		else
        {
		  var currentMapWidth = jQuery('#map').width();
		jQuery('#overlay, #overlayimage').width(currentMapWidth);
		jQuery('#overlayimage').height(jQuery('#map').height());
        }
}

//map.on('load', onLoad); // set proximity on map load
map.on('moveend', updateGeocoderProximity); // and then update proximity each time the map moves

function onLoad()
{
  var url = new URL(window.location.href);
  var orientation = url.searchParams.get("orientation");
  //var city = url.searchParams.get("city");
  if(orientation != null && orientation != "")
  {
    var data = JSON.parse(orientation);
    setOrientation(data.lat, data.lng, data.zoom, data.orientation, data.pitch, data.featureLat, data.featureLng, data.text, data.fontSize, data.font);
    if('marker' in data)
    {
      loadMarker(data['marker']);
    }
    else
    {
      loadMarker('heart');
    }
  }
  else
  {
    var splitTitle = $("meta[property='og:title']").attr("content").split("City");
    if(splitTitle[1]) 
    {
      setCity(splitTitle[0]);
    }
  }
 updateGeocoderProximity(); 
}

function setCity(cityName) 
{
  var geocodeURL = "https://api.mapbox.com/geocoding/v5/mapbox.places/" + encodeURI(cityName) + ".json?access_token=pk.eyJ1IjoiYW9ibG91ayIsImEiOiJjamVhbzVnajIxMXkwMzNsZTFqeTFldnUxIn0.bAGA6PRx08Gp82ed5ON9cA&country=us&types=place";
  jQuery.get(geocodeURL, function(response) {
    var coordinates = response.features[0].center;
    setOrientation(coordinates[1],coordinates[0],12.75,0,0);
    geojson.features[0].geometry.coordinates = [coordinates[0] - 0.005, coordinates[1] + 0.005];
    map.getSource('points').setData(geojson);
    resetEtsyCode();
  });
}

var cachedCenterLng = 0;
var cachedCenterLat = 0;
function updateGeocoderProximity() {
    // proximity is designed for local scale, if the user is looking at the whole world,
    // it doesn't make sense to factor in the arbitrary centre of the map
    if (map.getZoom() > 9) {
        var center = map.getCenter().wrap(); // ensures the longitude falls within -180 to 180 as the Geocoding API doesn't accept values outside this range
        geocoder.setProximity({ longitude: center.lng, latitude: center.lat });
    } else {
        geocoder.setProximity(null);
    }
	
	//if the point goes outside the bounds of the map then remove it
	if(!(
		map.getBounds()._ne.lng > geojson.features[0].geometry.coordinates[0] && 
		map.getBounds()._sw.lng < geojson.features[0].geometry.coordinates[0] && 
		map.getBounds()._ne.lat > geojson.features[0].geometry.coordinates[1] && 
		map.getBounds()._sw.lat < geojson.features[0].geometry.coordinates[1]
	))
	{
		geojson.features[0].geometry.coordinates = [map.getCenter().lng, map.getCenter().lat];
        try
        {
			map.getSource('points').setData(geojson);
        }
        catch (error)
        {
            // Points may not be set, so just ignore it
        }
	}
  	var isNew = cachedCenterLng != map.getCenter().lng || cachedCenterLat != map.getCenter().lat;
	cachedCenterLng = map.getCenter().lng;
	cachedCenterLat = map.getCenter().lat;
  	if(isNew)
    {
  		resetEtsyCode();
    }
}

var imageBlob;
var isSaved = false;

function drawToMap(imageReference)
{
	var img = new Image();
	img.src = assets[imageReference];
      
    img.onload = function()
    {
      var img = this;
      var canvasRead = document.createElement('canvas');
      canvasRead.width = img.width;
      canvasRead.height = img.height;
      canvasRead.getContext('2d').drawImage(img, 0, 0, img.width, img.height);
      var canvasReadData = canvasRead.getContext('2d').getImageData(0, 0, img.width, img.height);

      var mapCanvas = document.getElementsByClassName("mapboxgl-canvas")[0];
      var canvasRead2 = document.createElement('canvas');
      canvasRead2.width = img.width;
      canvasRead2.height = img.height;
      canvasRead2.getContext('2d').drawImage(mapCanvas, 0, 0, mapCanvas.width, mapCanvas.height, 0, 0, img.width, img.height);
      var canvasRead2Data = canvasRead2.getContext('2d').getImageData(0, 0, img.width, img.height);

      var canvasWrite = document.createElement('canvas');
      canvasWrite.width = img.width;
      canvasWrite.height = img.height;
      var canvasDataToWrite = canvasWrite.getContext('2d').getImageData(0, 0, img.width, img.height);

      var lowestJ = 99999;
      var highestJ = -1;
      var lowestI = 99999;
      var highestI = -1;
      var index = 0;
      for(var j=0; j<img.height; j++)
      {
          for(var i=0; i<img.width; i++)
          {
              if(canvasReadData.data[index + 3] == 0 && (canvasRead2Data.data[index + 0] + canvasRead2Data.data[index + 1] + canvasRead2Data.data[index + 2]) < 460)
              {
                  if(j < lowestJ) lowestJ = j;
                  if(j > highestJ) highestJ = j;
                  if(i < lowestI) lowestI = i;
                  if(i > highestI) highestI = i;
                  canvasDataToWrite.data[index + 0] = 0;
                  canvasDataToWrite.data[index + 1] = 0;
                  canvasDataToWrite.data[index + 2] = 0;
                  canvasDataToWrite.data[index + 3] = canvasRead2Data.data[index + 3];
              }
              index+=4;
          }
      }

      canvasRead.getContext('2d').clearRect(0,0,canvasRead.width,canvasRead.height);
      canvasRead.getContext('2d').putImageData(canvasDataToWrite, 0, 0);
      canvasWrite.width = highestI-lowestI;
      canvasWrite.height = highestJ-lowestJ;
      canvasWrite.getContext('2d').drawImage(canvasRead, lowestI, lowestJ, highestI-lowestI, highestJ-lowestJ, 0, 0, highestI-lowestI, highestJ-lowestJ);
      //var img = canvasWrite.toDataURL("image/png", 1.0);
      
      //imageBlob = dataURItoBlob(img);
	  //document.getElementById("File 1").setAttribute("value", img);
      var orientationArray = getOrientation();
      orientationArray['marker'] = selectedMarker;
	  document.getElementById("Orientation").setAttribute("value", JSON.stringify(orientationArray));
      
      try {
        const dT = new ClipboardEvent('').clipboardData || // Firefox < 62 workaround exploiting https://bugzilla.mozilla.org/show_bug.cgi?id=1422655
        new DataTransfer(); // specs compliant (as of March 2018 only Chrome)
        dT.items.add(new File([dataURItoBlob(img)], 'image.png'));
        document.getElementById("File 2").files = dT.files;
      } catch(err){}
      
      document.getElementById("product-form").submit();
    }
}

function drawToMap2(imageReference)
{
	var img = new Image();
	img.src = assets[imageReference];
      
    img.onload = function()
    {
      var img = this;
      var canvasRead = document.createElement('canvas');
      canvasRead.width = img.width;
      canvasRead.height = img.height;
      canvasRead.getContext('2d').drawImage(img, 0, 0, img.width, img.height);
      var canvasReadData = canvasRead.getContext('2d').getImageData(0, 0, img.width, img.height);

      var mapCanvas = document.getElementsByClassName("mapboxgl-canvas")[0];
      var canvasRead2 = document.createElement('canvas');
      canvasRead2.width = img.width;
      canvasRead2.height = img.height;
      canvasRead2.getContext('2d').drawImage(mapCanvas, 0, 0, mapCanvas.width, mapCanvas.height, 0, 0, img.width, img.height);
      var canvasRead2Data = canvasRead2.getContext('2d').getImageData(0, 0, img.width, img.height);

      var canvasWrite = document.createElement('canvas');
      canvasWrite.width = img.width;
      canvasWrite.height = img.height;
      var canvasDataToWrite = canvasWrite.getContext('2d').getImageData(0, 0, img.width, img.height);

      var lowestJ = 99999;
      var highestJ = -1;
      var lowestI = 99999;
      var highestI = -1;
      var index = 0;
      for(var j=0; j<img.height; j++)
      {
          for(var i=0; i<img.width; i++)
          {
              if(canvasReadData.data[index + 3] == 0 && (canvasRead2Data.data[index + 0] + canvasRead2Data.data[index + 1] + canvasRead2Data.data[index + 2]) < 460)
              {
                  if(j < lowestJ) lowestJ = j;
                  if(j > highestJ) highestJ = j;
                  if(i < lowestI) lowestI = i;
                  if(i > highestI) highestI = i;
                  canvasDataToWrite.data[index + 0] = 0;
                  canvasDataToWrite.data[index + 1] = 0;
                  canvasDataToWrite.data[index + 2] = 0;
                  canvasDataToWrite.data[index + 3] = canvasRead2Data.data[index + 3];
              }
              index+=4;
          }
      }

      canvasRead.getContext('2d').clearRect(0,0,canvasRead.width,canvasRead.height);
      canvasRead.getContext('2d').putImageData(canvasDataToWrite, 0, 0);
      canvasWrite.width = highestI-lowestI;
      canvasWrite.height = highestJ-lowestJ;
      canvasWrite.getContext('2d').drawImage(canvasRead, lowestI, lowestJ, highestI-lowestI, highestJ-lowestJ, 0, 0, highestI-lowestI, highestJ-lowestJ);
      //var img = canvasWrite.toDataURL("image/png", 1.0);
      
      //imageBlob = dataURItoBlob(img);
	  //document.getElementById("File 1").setAttribute("value", img);
      var dataObject = getOrientation();
      dataObject['marker'] = selectedMarker;
      
	  document.getElementById("etsyCode").value = JSON.stringify(dataObject);
    }
}

function drawToOutputEngraved(imageReference)
{
	var img = new Image();
	img.src = assets[imageReference];
      
    img.onload = function()
    {
      var img = this;
      var canvasRead = document.createElement('canvas');
      canvasRead.width = img.width;
      canvasRead.height = img.height;
      canvasRead.getContext('2d').drawImage(img, 0, 0, img.width, img.height);
      var canvasReadData = canvasRead.getContext('2d').getImageData(0, 0, img.width, img.height);

      var gl = map.getCanvas().getContext('webgl', {preserveDrawingBuffer: true});
	  var canvasRead2Data = new Uint8Array(gl.drawingBufferWidth * gl.drawingBufferHeight * 4);
	  gl.readPixels(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight, gl.RGBA, gl.UNSIGNED_BYTE, canvasRead2Data);
      
      var halfHeight = gl.drawingBufferHeight / 2 | 0;  // the | 0 keeps the result an int
      var bytesPerRow = gl.drawingBufferWidth * 4;
      // make a temp buffer to hold one row
      var temp = new Uint8Array(bytesPerRow);
      for (var y = 0; y < halfHeight; ++y) {
        var topOffset = y * bytesPerRow;
        var bottomOffset = (gl.drawingBufferHeight - y - 1) * bytesPerRow;
        // make copy of a row on the top half
        temp.set(canvasRead2Data.subarray(topOffset, topOffset + bytesPerRow));
        // copy a row from the bottom half to the top
        canvasRead2Data.copyWithin(topOffset, bottomOffset, bottomOffset + bytesPerRow);
        // copy the copy of the top half row to the bottom half 
        canvasRead2Data.set(temp, bottomOffset);
      }

      var canvasWrite = document.createElement('canvas');
      canvasWrite.style.imageRendering = "-moz-crisp-edges -webkit-crisp-edges pixelated crisp-edges";
      canvasWrite.width = img.width;
      canvasWrite.height = img.height;
      var canvasDataToWrite = canvasWrite.getContext('2d').getImageData(0, 0, img.width, img.height);

      var lowestJ = 99999;
      var highestJ = -1;
      var lowestI = 99999;
      var highestI = -1;
      var index = 0;
      for(var j=0; j<img.height; j++)
      {
          for(var i=0; i<img.width; i++)
          {
              if(canvasReadData.data[index + 3] == 0 && canvasRead2Data[index + 3] > 0 && (canvasRead2Data[index + 0] + canvasRead2Data[index + 1] + canvasRead2Data[index + 2]) < 690)
              {
                  canvasDataToWrite.data[index + 0] = canvasRead2Data[index + 0];
                  canvasDataToWrite.data[index + 1] = canvasRead2Data[index + 1];
                  canvasDataToWrite.data[index + 2] = canvasRead2Data[index + 2];
                  canvasDataToWrite.data[index + 3] = 255;
              }
              else
              {
                  canvasDataToWrite.data[index + 0] = 255;
                  canvasDataToWrite.data[index + 1] = 255;
                  canvasDataToWrite.data[index + 2] = 255;
                  canvasDataToWrite.data[index + 3] = 255;
              }
            if(canvasReadData.data[index + 3] == 0)
            {
              if(j < lowestJ) lowestJ = j;
              if(j > highestJ) highestJ = j;
              if(i < lowestI) lowestI = i;
              if(i > highestI) highestI = i;
            }
              index+=4;
          }
      }

      canvasRead.getContext('2d').clearRect(0,0,canvasRead.width,canvasRead.height);
      canvasRead.getContext('2d').putImageData(canvasDataToWrite, 0, 0);
      canvasWrite.width = highestI-lowestI;
      canvasWrite.height = highestJ-lowestJ;
      canvasWrite.getContext('2d').drawImage(canvasRead, lowestI, lowestJ, highestI-lowestI, highestJ-lowestJ, 0, 0, highestI-lowestI, highestJ-lowestJ);
      var imgOut = canvasWrite.toDataURL("image/png", 1.0);
      
	  document.getElementById("outputFile").innerHTML = "<img src='"+imgOut+"'>";
      
      resizeImage(imgOut, function(result) {document.getElementById("outputSvg").innerHTML = result});
      drawTextToOutput(imageReference);
    }
}

function drawToOutputEngraved2(imageReference)
{
	var img = new Image();
    img.src = assets[imageReference];
      
    img.onload = function()
    {
        var img = this;
        var canvasRead = document.createElement('canvas');
        var mapImg = new Image();
        mapImg.src = map.getCanvas().toDataURL("image/png", 1.0)
        mapImg.onload = function()
        {
            canvasRead.width = mapImg.width;
      	    canvasRead.height = mapImg.height;
      		var contextRead = canvasRead.getContext('2d');
        	contextRead.globalCompositeOperation = "source-out";
      		contextRead.fillStyle = "#FFFFFF";
      		contextRead.fillRect(0,0,canvasRead.width,canvasRead.height);
      		contextRead.globalCompositeOperation = "destination-in";
      		var overlayYPosition = (canvasRead.height - canvasRead.width * img.height / img.width) / 2;
      		//contextRead.drawImage(img, 0, 0, canvasRead.width, canvasRead.height);
      		contextRead.drawImage(img, 0, overlayYPosition, canvasRead.width, canvasRead.width * img.height / img.width);
      		contextRead.globalCompositeOperation = "source-over";
      		contextRead.fillRect(0,0, canvasRead.width, overlayYPosition);
      		contextRead.fillRect(0,canvasRead.height - overlayYPosition, canvasRead.width, canvasRead.height);
        	contextRead.globalCompositeOperation = "source-out";
        	contextRead.drawImage(this, 0, 0);
        	contextRead.globalCompositeOperation = "destination-over";
      		contextRead.fillRect(0,0,canvasRead.width,canvasRead.height);
        	var imgOut = canvasRead.toDataURL("image/png", 1.0);
        	resizeImage(imgOut, function(result) {
                document.getElementById("outputSvg").innerHTML = result;
                var buyer = document.getElementById('buyer-name');
                if(!document.getElementById('backText'))
                {
                    var fileName;
                    if(buyer.value != '')
                    {
                        fileName = buyer.value + "_map.svg";
                    }
                    else
                    {
                        fileName = "map_" + Date.now() + ".svg";
                    }
                    var data = window.btoa(result);
	  	            document.getElementById("outputFile").innerHTML = "<img width='500px' height='500px' src='" + imgOut + "'></img>";
                    document.getElementById('svg-link').setAttribute('download', fileName);
                    document.getElementById('svg-link').setAttribute('href', "data:image/svg+xml;base64," + data);
                    document.getElementById('svg-link').click();
                }
                else
                {
                    var frontFileName, backFileName;
                    if(buyer.value != '')
                    {
                        frontFileName = buyer.value + "front_map.svg";
                        backFileName = buyer.value + "back_map.svg";
                    }
                    else
                    {
                        frontFileName = "map_front_" + Date.now() + ".svg";
                        backFileName = "map_back_" + Date.now() + ".svg";
                    }
                    var data = window.btoa(result);
	  	            document.getElementById("outputFile").innerHTML = "<img width='500px' height='500px' src='" + imgOut + "'></img>";
                    document.getElementById('svg-link').setAttribute('download', frontFileName);
                    document.getElementById('svg-link').setAttribute('href', "data:image/svg+xml;base64," + data);
                    document.getElementById('svg-link').click();
                    var font = document.getElementById('backTextFont').value;
                    var fontSize = document.getElementById('fontSize').value;
                    var text = document.getElementById('backText').value;
                    createTextPath(font, text, 0, 0, fontSize, true, function(){
                        console.log('a');
                        var backData = window.btoa(document.getElementById("engraved-svg-wrapper").innerHTML);
                        document.getElementById('back-svg-link').setAttribute('download', backFileName);
                        document.getElementById('back-svg-link').setAttribute('href', "data:image/svg+xml;base64," + backData);
                        document.getElementById('back-svg-link').click();
                    });
                  console.log('b');
                }
            });
        }
    }
}

function createTextPath(fontFile, text, x, y, fontSize, centeredX, callback, options = null)
{
    if (text.length == 0) return;
    opentype.load(fontFile, function (error, font)
    {
        if (error)
        {
            console.log(error);
        }
        var lineHeight = fontSize * (font.ascender - font.descender) / font.unitsPerEm;
        var linePaddingTop = 0;
        lineHeight += linePaddingTop;
        var lines = text.split(/\\n|\n/);
        var paths = [];
        var lineWidth = 0;
        var glyph, kerning, charWidth;
        var lineX;
        var lineY = y;
        lines.forEach(function (line)
        {
            if (line.length == 0)
            {
                lineY += lineHeight;
                return;
            }
            if (centeredX)
            {
                lineWidth = 0;
                for (var i = 0; i < line.length - 1; ++i)
                {
                    glyph = font.charToGlyph(line[i]);
                    kerning = font.getKerningValue(line[i], line[i + 1]);
                    charWidth = glyph.advanceWidth;
                    lineWidth += fontSize * (charWidth + kerning) / (font.unitsPerEm);
                }
                kerning = 0;
                glyph = font.charToGlyph(line[i]);
                charWidth = glyph.advanceWidth;
                lineWidth += fontSize * (charWidth + kerning) / (font.unitsPerEm);
                lineX = x - lineWidth / 2;
                lineY += lineHeight;
            }
            else
            {
                lineX = x;
                lineY += lineHeight;
            }
            paths.push(font.getPath(line, lineX, lineY, fontSize, options).toPathData());
        });
        var path = paths.join("");
        createEngravedSvg(path, x, y, 100, 100, callback);
        //svg.rect(textBoxWidth, textBoxHeight).move(x, y).attr({ fill: "none", 'stroke-width': "2px", 'stroke': '#FF0000' });
    });
}

function createEngravedSvg(path, x, y, svgWidth, svgHeight, callback)
{
    document.getElementById('engraved-svg-wrapper').innerHTML = "";
    var svg = SVG("engraved-svg-wrapper");
    svg.attr("width", null);
    svg.attr("height", null);
    svg.size(svgWidth + "mm", svgHeight + "mm");
    svg.viewbox(0, 0, svgWidth, svgHeight);
    var path = svg.path(path);
    // Scale the svg down to roughly match handmade versions
    var scale = 0.04492;
    path.size(path.width() * scale, path.height() * scale);
    var bbox = path.bbox();
    path.move(x, y);
    callback();
}

function drawToOutputCut(imageReference, callback=null)
{
      var style = jewelryStyle;
      var urlStart = "https://api.mapbox.com/styles/v1/" + style.split("mapbox://styles/")[1] + "/static";
      var center = map.getCenter();
      var zoom = map.getZoom();
      var coordinateString = center['lng'] + ',' + center['lat'] + "," + zoom + ",0,0";
      var staticImageUrl = urlStart + "/" + coordinateString + "/500x500@2x?access_token=" + mapboxgl.accessToken;
      var mapImage = new Image();
      mapImage.src = staticImageUrl;
      mapImage.crossOrigin = "Anonymous";
    mapImage.onload = function()
    {
	var img = new Image();
	img.src = assets[imageReference];
      img.onload = function(mapImage) {
        var canvasRead = document.createElement('canvas');
      canvasRead.width = img.width;
      canvasRead.height = img.height;
      canvasRead.getContext('2d').drawImage(img, 0, 0, img.width * 2, img.height * 2);
      var canvasReadData = canvasRead.getContext('2d').getImageData(0, 0, img.width, img.height);
          var canvasWrite = document.createElement('canvas');
          canvasWrite.style.imageRendering = "-moz-crisp-edges -webkit-crisp-edges pixelated crisp-edges";
          canvasWrite.width = mapImage.width;
          canvasWrite.height = mapImage.height;
          var overlayYPosition = (canvasWrite.height - canvasWrite.width * img.height / img.width) / 2;
          var writeContext = canvasWrite.getContext('2d');
          var overlayFillColor = "#000000";
          writeContext.drawImage(mapImage, 0, 0, canvasWrite.width, canvasWrite.height);
          writeContext.drawImage(img, 0, overlayYPosition, canvasWrite.width, canvasWrite.width * img.height / img.width);
          writeContext.fillStyle = overlayFillColor;
          writeContext.fillRect(0,0, canvasWrite.width, overlayYPosition);
          writeContext.fillRect(0,canvasWrite.height - overlayYPosition, canvasWrite.width, canvasWrite.height);
      	  //writeContext.globalCompositeOperation = "hue";
          //writeContext.fillStyle = "color(244, 225, 113)";
          //writeContext.fillRect(0,0,canvasWrite.width,canvasWrite.height);
          var imgOut = canvasWrite.toDataURL("image/png", 1.0);
          var svgConversionUrl = "https://www.oblouk.com/JewelryUtilities/convert.php";
          var args = "-i";
          jQuery.post(svgConversionUrl, {"file":imgOut, "fileType": "svg", "width": 1, "args": args}, function(data)
	      {
              try
              {
                  var svg = window.atob(data);
              }
              catch (error)
              {
                  if (error instanceof DOMException)
                  {
                      console.error(data);    
                  }
                  else
                  {
                      console.error(error);    
                  }
                  return;
              }
              document.getElementById("outputFile").innerHTML = "<img width='500px' height='500px' src='" + imgOut + "'></img>";
	  	      document.getElementById("outputSvg").innerHTML = svg;
              jQuery.post(svgConversionUrl, {"file":imgOut, "fileType": "dxf", "width": 40, "args": args}, function(data)
	          {
                  if (callback)
                  {
                      callback(data, mapImage);
                  }
                  else
                  {
                      // Download the dxf by default
                      var buyer = document.getElementById('buyer-name');
                      var fileName;
                      if(buyer.value != '')
                      {
                          fileName = buyer.value + "_map.dxf";
                      }
                      else
                      {
                          fileName = "map_" + Date.now() + ".dxf";
                      }
                      document.getElementById('svg-link').setAttribute('download', fileName);
                      document.getElementById('svg-link').setAttribute('href', "data:application/dxf;base64," + data);
                      document.getElementById('svg-link').click();
                  }
              });
          });
      }.bind(img, this);
    }
}

function drawTextToOutput(imageReference)
{
	var img = new Image();
	img.src = assets[imageReference];
      
    img.onload = function()
    {
      var img = this;
      var canvasRead = document.createElement('canvas');
      canvasRead.width = img.width*2;
      canvasRead.height = img.height*2;
      canvasRead.getContext('2d').drawImage(img, 0, 0, img.width, img.height, 0, 0, img.width*2, img.height*2);
      var canvasReadData = canvasRead.getContext('2d').getImageData(0, 0, img.width*2, img.height*2);
      var canvasRead2Data = backCanvas.getContext("2d").getImageData(0, 0, img.width*2, img.height*2);

      var canvasWrite = document.createElement('canvas');
      canvasWrite.style.imageRendering = "-moz-crisp-edges -webkit-crisp-edges pixelated crisp-edges";
      canvasWrite.width = img.width*2;
      canvasWrite.height = img.height*2;
      var canvasDataToWrite = canvasWrite.getContext('2d').getImageData(0, 0, img.width*2, img.height*2);

      var lowestJ = 99999;
      var highestJ = -1;
      var lowestI = 99999;
      var highestI = -1;
      var index = 0;
      for(var j=0; j<img.height*2; j++)
      {
          for(var i=0; i<img.width*2; i++)
          {
              if(canvasReadData.data[index + 3] == 0 && canvasRead2Data.data[index + 3] > 0 && (canvasRead2Data.data[index + 0] + canvasRead2Data.data[index + 1] + canvasRead2Data.data[index + 2]) < 690)
              {
                  canvasDataToWrite.data[index + 0] = canvasRead2Data.data[index + 0];
                  canvasDataToWrite.data[index + 1] = canvasRead2Data.data[index + 1];
                  canvasDataToWrite.data[index + 2] = canvasRead2Data.data[index + 2];
                  canvasDataToWrite.data[index + 3] = 255;
              }
              else
              {
                  canvasDataToWrite.data[index + 0] = 255;
                  canvasDataToWrite.data[index + 1] = 255;
                  canvasDataToWrite.data[index + 2] = 255;
                  canvasDataToWrite.data[index + 3] = 255;
              }
            if(canvasReadData.data[index + 3] == 0)
            {
              if(j < lowestJ) lowestJ = j;
              if(j > highestJ) highestJ = j;
              if(i < lowestI) lowestI = i;
              if(i > highestI) highestI = i;
            }
              index+=4;
          }
      }

      canvasRead.getContext('2d').clearRect(0,0,canvasRead.width,canvasRead.height);
      canvasRead.getContext('2d').putImageData(canvasDataToWrite, 0, 0);
      canvasWrite.width = (highestI-lowestI)/2;
      canvasWrite.height = (highestJ-lowestJ)/2;
      canvasWrite.getContext('2d').drawImage(canvasRead, lowestI, lowestJ, highestI-lowestI, highestJ-lowestJ, 0, 0, (highestI-lowestI)/2, (highestJ-lowestJ)/2);
      var imgOut = canvasWrite.toDataURL("image/png", 1.0);
      
	  document.getElementById("outputFile").innerHTML += "<img src='"+imgOut+"'>";
      resizeImage(imgOut, function(result) {console.log(result)});
    }
}

function dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
          byteString = atob(dataURI.split(',')[1]);
      else
          byteString = unescape(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {type:mimeString});
  }


  
  
  var backCanvas = document.getElementById("pendantBackCanvas");
  var BCANVAS = backCanvas.getContext("2d");

  function renderBack()
  {
      if(!document.getElementById("backText")) return;
    
      BCANVAS.font= "1px Monotype Corsiva";
      BCANVAS.fillText("Load font", 0, 0);
      BCANVAS.font= "1px monospace";
      BCANVAS.fillText("Load font", 0, 0);
      BCANVAS.font= "1px Courier New";
      BCANVAS.fillText("Load font", 0, 0);
    
      BCANVAS.restore();
      BCANVAS.clearRect(0,0,backCanvas.width,backCanvas.height);
      // The values of the options are ttf files, so we need to get the names of the fonts from the innerHTML
      var fontSelect = document.getElementById("backTextFont");
      var font = fontSelect.options[fontSelect.selectedIndex].innerHTML;
      BCANVAS.font= document.getElementById("fontSize").value+"px "+ font;
      var textValue = document.getElementById("backText").value;
      var textLines = textValue.split("\n");
      for(var i=0; i<textLines.length; i++)
      {
          BCANVAS.fillText(textLines[i], 500 - (BCANVAS.measureText(textLines[i]).width/2), 500 - ((document.getElementById("fontSize").value * .3) * textLines.length) + (document.getElementById("fontSize").value * i));
      }
      BCANVAS.save();
  }

  function openTab(evt, tabName) {
      // Declare all variables
      var i, tabcontent, tablinks;

      // Get all elements with class="tabcontent" and hide them
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = "none";
      }

      // Get all elements with class="tablinks" and remove the class "active"
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
      }

      // Show the current tab, and add an "active" class to the button that opened the tab
      document.getElementById(tabName).style.display = "block";
      evt.currentTarget.className += " active";
    
	  var displayStatus = document.getElementById("pendantBack").style.display;
      if(displayStatus == "block") displayStatus = "inline-block";
      document.getElementById("backInfo").style.display = displayStatus;
  }

	
	
	// Required for drag and drop file access
	jQuery.event.props.push('dataTransfer');

	$(function(){
		
		resizeImage = function(file, callback) {
			var image = new Image();
			image.onload = function(){
 		    	var svgOutput = "";
				var canvas = document.createElement("canvas");
				var ctx = canvas.getContext("2d");
				ctx.clearRect(0, 0, canvas.width, canvas.height);
				canvas.width = image.width;
				canvas.height = image.height;
				ctx.drawImage(image, 0, 0, image.width, image.height);
				
				var imgData = ctx.getImageData(0,0,canvas.width,canvas.height);
				var data = imgData.data;
					// enumerate all pixels
				// each pixel's r,g,b,a datum are stored in separate sequential array elements
				
				svgOutput += '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink= "http://www.w3.org/1999/xlink" height="'+image.height+'" width="'+image.width+'"><path style="fill:#000000" d="';
				var index = 0;
				var pixelArray = [];
				for(var j=0; j<image.height; j++)
				{
					pixelArray.push([]);
					for(var i=0; i<image.width; i++)
					{
						if(imgData.data[index + 3] != 0 && (imgData.data[index + 0] + imgData.data[index + 1] + imgData.data[index + 2]) < 460)
						{
							pixelArray[j][i] = 1;
						}
						else
						{
							pixelArray[j][i] = 0;
						}
						index+=4;
					}
				}
					
				var dimensionIndex = 0;
				var bestSvgOutput = "";
				var bestDimensionListString = "";
				var candidateSvgOutput = "";
				var dimensionList = [];
				var iterations = 12;
				var largestDimension = 19;
				
				for(var i=largestDimension; i>=1; i--)
				{
					for(var j=largestDimension; j>=i; j--)
					{
						if(i != j)
						{
							dimensionList.push({"x": i, "y": j});
							dimensionList.push({"x": j, "y": i});
						}
						else
						{
							dimensionList.push({"x": i, "y": j});
						}
					}
				}
				for(var i=0; i<dimensionList.length; i++)
				{
					for(var j=0; j<dimensionList.length-1; j++)
					{
						if(dimensionList[j].x * dimensionList[j].y < dimensionList[j+1].x * dimensionList[j+1].y)
						{
							var tempValue = dimensionList[j];
							dimensionList[j] = dimensionList[j+1];
							dimensionList[j+1] = tempValue;
						}
					}
				}
				
				for(var ip=1; ip<=iterations; ip++)
				{
					while(dimensionIndex < dimensionList.length)
					{
						var dimensions = dimensionList[dimensionIndex];
						
						//search for 2D object
						for(var y=0; y<=pixelArray.length-dimensions.y; y++)
						{
							for(var x=0; x<=pixelArray[0].length-dimensions.x; x++)
							{
								var hits=0;
								var x2 = x;
								var y2 = y;
								while(hits < (dimensions.x * dimensions.y) && pixelArray[y2][x2] == ip)
								{
									hits++;
									if(hits % dimensions.x == 0)
									{
										x2 = x;
										y2++;
									}
									else
									{
										x2++;
									}
								}
								if(hits == (dimensions.x * dimensions.y))
								{
									candidateSvgOutput += getSvgOutput(x,y,dimensions.x,dimensions.y);
									
									for(var y3=y; y3<y+dimensions.y; y3++)
									{
										for(var x3=x; x3<x+dimensions.x; x3++)
										{
											pixelArray[y3][x3] = ip+1;
										}
									}
								}
							}
						}
						dimensionIndex++;
					}
					
					//save if best
					if(candidateSvgOutput.length < bestSvgOutput.length || bestSvgOutput == "")
					{
						bestDimensionListString = JSON.stringify(dimensionList);
						bestSvgOutput = candidateSvgOutput;
						console.log("New Best: "+ip+" - "+bestSvgOutput.length);
					}
					else
					{
						dimensionList = JSON.parse(bestDimensionListString);
					}
					
					//reset index
					dimensionIndex = 0;
					candidateSvgOutput = "";
					
					//flip random sets of values
					var chanceOfFlipping = ((iterations+1)-ip)/iterations;
					for(var i=1; i<dimensionList.length-2; i++)
					{
						if(weightedRandomBoolean(chanceOfFlipping)) //basic sim annealing
						{
							if((dimensionList[i].x*dimensionList[i].y) == (dimensionList[i+1].x*dimensionList[i+1].y))
							{
								var temp = dimensionList[i];
								dimensionList[i] = dimensionList[i+1];
								dimensionList[i+1] = temp;
							}
						}
					}
				};
					
					svgOutput += bestSvgOutput;
					svgOutput += '" id="path5831" /></svg>';
					
					//document.getElementById("outputSvg").innerHTML = svgOutput;
                    callback(svgOutput);
				image.src = this.result;
			}
            image.src = file;
		};
	});
	
	function getSvgOutput(x, y, width, height)
	{
		return "M "+x+" "+y+" L "+(x+width)+" "+(y)+" L "+(x+width)+" "+(y+height)+" L "+(x)+" "+(y+height)+" Z";
	}
	
	function rand(min,max)
	{
		return Math.round(min+(Math.random()*(max-min)));
	}
	//[inclusive,inclusive]
	
	function weightedRandomBoolean(percent)
	{
		if(rand(0,(Math.round(1/percent))) == 1)
		{
			return true;
		}
		else
		{
			return false;
		}
	}

function resetEtsyCode()
{
  	if(document.getElementById("etsyCode"))
    {
      document.getElementById("etsyCode").value = '';
    }
}

function copyCodeToClipboard()
{
    var copyText = document.getElementById("etsyCode");

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /*For mobile devices*/
	copyText.blur();

    /* Copy the text inside the text field */
    document.execCommand("copy"); 
	document.getElementById("copyStatus").innerHTML = "Copied!";
}